const PopUpContainer = ({ children }) => {
  return (
    <div className="absolute m-auto inset-0 w-fit h-fit bg-white z-10">
      {children}
    </div>
  );
};

export default PopUpContainer;
